import React, { Component } from 'react';
import axios from 'axios';
import { submitedPrayersUrl } from '../../helpers/api_routes';

export default class PrayerForm extends Component {

	/*

	$ curl -X POST -H "Accept: application/json" --data 'submitted_prayer[email]=kvesic.mislav@gmail.com&submitted_prayer[first_name]=Mislav&submitted_prayer[last_name]=Kvesic&submitted_prayer[content]=IprayYouPray&submitted_prayer[city]=Osijek&submitted_prayer[prayer_for]=YourM&submitted_prayer[gdpr_accept]=1' [rootUrl]/submitted_prayers

	*/
	constructor(props) {
		super(props);
		this.state = {
			prayer_for: '',
			content: '',
			city: '',
			first_name: '',
			last_name: '',
			email: '',
			gdpr_accept: '0',
			status: '',
			statusCode: '',
			submitted: false,
			is_anonymous: '0',
			charLeft: 250,
			maxLength: 250
		};
	}


	charCounter = (e) => {
	}

	changeHandler = e => {
		this.setState({ [e.target.name]: e.target.value });

		if (e.target.maxLength === this.state.maxLength) {
			this.setState({charLeft: e.target.maxLength - e.target.value.length})
		}
	};

	checkboxHandler = e => {
		this.setState({ [e.target.name]: e.target.checked ? '1' : '0' });
	};

	isFormValid = () => {
		return (
			this.state.prayer_for.trim().length > 0 &&
			this.state.content.trim().length > 0 &&
			this.state.email.trim().length > 0 &&
			this.state.first_name.trim().length > 0 &&
			this.state.last_name.trim().length > 0 &&
			this.state.gdpr_accept === '1'
		);
	};

	submitHandler = e => {
		e.preventDefault();

		if (!this.isFormValid()) {
			this.setState({
				statusCode: 422,
				status: 'Please complete all required fields and accept the email consent.'
			});
			return;
		}

		const data = {
			submitted_prayer: {
				first_name: this.state.first_name,
				last_name: this.state.last_name,
				city: this.state.city,
				email: this.state.email,
				prayer_for: this.state.prayer_for,
				content: this.state.content,
				gdpr_accept: this.state.gdpr_accept,
				is_anonymous: this.state.is_anonymous
			}
		};

		axios
			.post(submitedPrayersUrl.validate, data)
			.then(response => {
				axios
					.post(submitedPrayersUrl.prayers, data)
					.then(res => {
						this.setState({
							statusCode: res.status,
							status: res.data.status,
							submitted: res.status === 200
						}, () => {
							if (this.state.submitted) {
								this.props.onSubmitted && this.props.onSubmitted();
								window.scrollTo({ top: 0, behavior: 'smooth' });
							}
						});
					})
					.catch(error => {
						console.log(error);
					});
			})
			.catch(error => {
				console.log(error);
			});
	};

	render() {
		const {
			email,
			first_name,
			last_name,
			content,
			city,
			prayer_for,
			gdpr_accept,
			is_anonymous
		} = this.state;
		const isFormValid = this.isFormValid();

		if (this.state.submitted) {
			return (
				<div className='form form--border'>
					<div className='form__status form__status--ok'>
						<span>Your prayer has been sent!</span>
					</div>
				</div>
			);
		}

		return (
			<form
				action='submit'
				className='form form--border'
				onSubmit={this.submitHandler}
			>
				<fieldset className='form__fieldset'>
					<div className="input--checkbox__wrap">
						<input
							type='checkbox'
							className='input--checkbox'
							name='is_anonymous'
							id='is_anonymous'
							checked={is_anonymous === '1'}
							onChange={this.checkboxHandler}
						/>
						<label htmlFor="is_anonymous" className="no-margin">I want to be anonymous</label>
					</div>
				</fieldset>
				<fieldset className='form__fieldset'>
					<label htmlFor=''>Praying for (max 25. characters):</label>
					<input
						type='text'
						className='input input--text'
						name='prayer_for'
						maxLength='25'
						value={prayer_for}
						onChange={this.changeHandler}
					/>
				</fieldset>
				<fieldset className='form__fieldset'>
					<label htmlFor=''>My prayer:</label>
					<textarea
						name='content'
						cols='30'
						rows='10'
						maxLength={this.state.maxLength}
						className='textarea'
						value={content}
						onChange={this.changeHandler}
					></textarea>
					<div className="align-right"><span className="gray align-right">{this.state.charLeft}</span></div>
				</fieldset>
				<fieldset className='form__fieldset'>
					<label htmlFor=''>Location (Country or City):</label>
					<input
						type='text'
						className='input input--text'
						name='city'
						value={city}
						onChange={this.changeHandler}
					/>
				</fieldset>
				<fieldset className="form__fieldset">
					<p className="gray text--large"> 
					In order for us to confirm receipt of your prayer request please provide the following details:
					</p>
				</fieldset>
				<fieldset className='form__fieldset'>
					<label htmlFor=''>First Name:</label>
					<input
						type='text'
						className='input input--text'
						name='first_name'
						value={first_name}
						onChange={this.changeHandler}
					/>
				</fieldset>
				<fieldset className='form__fieldset'>
					<label htmlFor=''>Last Name:</label>
					<input
						type='text'
						className='input input--text'
						name='last_name'
						value={last_name}
						onChange={this.changeHandler}
					/>
				</fieldset>
				<fieldset className='form__fieldset'>
					<label htmlFor=''>Your Email:</label>
					<input
						type='email'
						className='input input--text'
						name='email'
						value={email}
						onChange={this.changeHandler}
					/>
				</fieldset>
				<fieldset className='form__fieldset'>
					<div className="input--checkbox__wrap">
						<input
							type='checkbox'
							className='input--checkbox'
							name='gdpr_accept'
							id='gdpr_accept'
							checked={gdpr_accept === '1'}
							onChange={this.checkboxHandler}
						/>
						<label htmlFor="gdpr_accept" className="no-margin">I accept that my email address will be used to provide me with an opportunity to subscribe to regular emails from Digital Church Platform</label>
					</div>
				</fieldset>
				<input
					type='submit'
					className={`btn btn--full ${
						isFormValid
							? 'btn--primary'
							: 'btn--transparent'
					}`}
					value='Send'
				/>
				{this.state.status.length > 0 && (
					<div
						className={`form__status ${
							this.state.statusCode === 200
								? 'form__status--ok'
								: 'form__status--error'
						}`}
					>
						<span>{this.state.status}</span>
					</div>
				)}
			</form>
		);
	}
}
